// ---------------------------------------------------------------------------
// Token usage arithmetic (AL-1850)
// ---------------------------------------------------------------------------
// Pulled out of AccountHealthZone so the topbar pill and the channels health
// bar agree on what "68%" means. Both read the same two numbers from
// /api/users/me.
// ---------------------------------------------------------------------------

/**
 * Used as a percentage of the limit, rounded.
 *
 * A limit of zero or less reads as 100%: there is no allowance left to spend,
 * and reporting 0% there would say the opposite. Capped at 999 so an account
 * far past its cap cannot stretch the layout.
 */
export function tokenPercent(used: number, limit: number): number {
  if (limit <= 0) return 100;
  return Math.min(Math.round((used / limit) * 100), 999);
}

/** What is left of the allowance, never negative. */
export function tokensRemaining(used: number, limit: number): number {
  return Math.max(limit - used, 0);
}
